import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import {
  Card,
  CardBody,
  Col,
  Row,
  Container,
  Badge,
  CardTitle,
  Table,
} from "reactstrap";
//import action

// Pages Components
import CardUser from "./CardUser";
import ChartUser from "./Chart";
import NFTUser from "./NFT";
import Transactions from "./Transactions";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";
import "../../assets/scss/style.css";
import Web3 from "web3";
import { ContractoutPut } from "contract/Abi";
import Piechart from "./NFT";
import Breadcrumb from "../../components/Common/Breadcrumb";

const Dashboard = (props) => {
  //meta title
  document.title = "Dashboard";
  const history = useHistory();
  const [symbol, SetSymbol] = useState("");
  const [contractTokenSupply, setContractTokenSupply] = useState(0);
  const init = async () => {
    if (window.ethereum) {
      const web3Provider = new Web3(
        "https://goerli.infura.io/v3/407d4727d10847209abf3673e7c7e099" ||
          Web3.givenProvider
      );
      const instance = new web3Provider.eth.Contract(
        ContractoutPut.abi,
        "0xBB7D1B1606922588A22a1d85F128e439c50082cB"
      );
      const totalSupply = await instance.methods.totalSupply().call();
      // setAnalyticsData((prv) => ({ ...prv, tokenSupply: totalSupply }))
      const symbol = await instance.methods.symbol().call();
      const TOKEN_MAX_SUPPLY = await instance.methods.TOKEN_MAX_SUPPLY().call();
      SetSymbol(symbol);
      const maxSupply = TOKEN_MAX_SUPPLY.toString();
      Number(maxSupply).toFixed(2) / 10 ** 18;
      console.log(maxSupply, "TOKEN_MAX_SUPPLY");
      // setNetwork({
      //   symbol: symbol,
      // })

      // setAnalyticsData({ ...analyticsData, tokenSupply: totalSupply / 1e18 })
      setContractTokenSupply(Number(totalSupply) / 1e18);
      // changeApiStatus(false, '')
    }
  };
  useEffect(() => {
    init();
  }, []);

  return (
    <React.Fragment>
      <div className="page-content margin-custom">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title={"Dashboard"} breadcrumbItem={"dashboard"} />

          <Row>
            <Col xl="12">
              <CardUser
                resultStats=""
                dataColors='["--bs-primary", "--bs-warning"]'
              />
            </Col>
            {/* <Col xl="8">
              <ChartUser
                resultGraph=""
                resultGraphStats=""
                dataColors='["--bs-secondary", "--bs-warning"]'
              />
            </Col> */}
            <Col xl="6">
              <Piechart
                // dataColors='["--bs-secondary", "--bs-warning"]'
                series={contractTokenSupply}
                symbol={symbol}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
};

export default withTranslation()(Dashboard);
